export const UPDATE_LOCALE = 'locale.UPDATE_LOCALE';



// WEBPACK FOOTER //
// ./src/store/locale/types.js